import HttpClientToken from '../../services/HttpClientToken';

import { defaultSexo, SexoProps } from '../../interfaces/catalogos/SexoInterface';

export const Sexo = () => {

    return new Promise<SexoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Sexo/', token)
            .then( ({ data } : { data : SexoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerSexo = () => {

    return new Promise<SexoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Sexo/ObtenerSexo', token)
            .then( ({ data } : { data : SexoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarSexo = ( params: SexoProps ) => {

    return new Promise<SexoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sexo/Actualizar', params, token)
            .then( ({ data } : { data : SexoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSexo } );
            });

        }

    });

}

export const AgregarSexo = ( params: SexoProps ) => {

    return new Promise<SexoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sexo/Agregar', params, token)
            .then( ({ data } : { data : SexoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSexo } );
            });

        }

    });

}
